import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Utils } from '../utils/utils';
import {AppComponent} from "../app.component";

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  static token: string = null;

  constructor(private http: HttpClient) { }

  public get<T>(url: string, authenticated: boolean = false): Observable<T> {
    let headers = new HttpHeaders();
    if (authenticated) {
      headers = headers.append('Authorization', 'Bearer ' + ApiService.token);
    }
    headers = headers.append('X-Mutuelle', environment.mutuelleCode);
    if (AppComponent.enterprise.value) {
      headers = headers.append('X-Enterprise', AppComponent.enterprise.value?.id);
    }
    const baseUrl = environment.apiBaseUrl;
    return this.http.get<T>(Utils.combineURLs([baseUrl, url]), { headers });
  }

  public put<T>(url: string, body: any, authenticated: boolean = false): Observable<T> {
    let headers = new HttpHeaders();
    if (authenticated) {
      headers = headers.append('Authorization', 'Bearer ' + ApiService.token);
    }
    headers = headers.append('X-Mutuelle', environment.mutuelleCode);
    if (AppComponent.enterprise.value) {
      headers = headers.append('X-Enterprise', AppComponent.enterprise.value?.id);
    }
    const baseUrl = environment.apiBaseUrl;
    return this.http.put<T>(Utils.combineURLs([baseUrl, url]), body, { headers });
  }

  public delete<T>(url: string, authenticated: boolean = false): Observable<T> {
    let headers = new HttpHeaders();
    if (authenticated) {
      headers = headers.append('Authorization', 'Bearer ' + ApiService.token);
    }
    headers = headers.append('X-Mutuelle', environment.mutuelleCode);
    if (AppComponent.enterprise.value) {
      headers = headers.append('X-Enterprise', AppComponent.enterprise.value?.id);
    }
    const baseUrl = environment.apiBaseUrl;
    return this.http.delete<T>(Utils.combineURLs([baseUrl, url]), { headers });
  }

  public post<T>(url: string, body: any, authenticated: boolean = false): Observable<T> {
    let headers = new HttpHeaders();
    if (authenticated) {
      headers = headers.append('Authorization', 'Bearer ' + ApiService.token);
    }
    headers = headers.append('X-Mutuelle', environment.mutuelleCode);
    if (AppComponent.enterprise.value) {
      headers = headers.append('X-Enterprise', AppComponent.enterprise.value?.id);
    }
    const baseUrl = environment.apiBaseUrl;
    return this.http.post<T>(Utils.combineURLs([baseUrl, url]), body, { headers });
  }
}
